import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {from, Observable, switchMap} from 'rxjs';
import {environment} from '../../environments/environment';

export interface MapsSettings {
  provider: 'mapbox' | 'here' | 'none' | string;
  enabled: boolean;
  configured: boolean;
  apiKeyMasked?: string | null;
  apiKeyLength?: number | null;
  hasApiKey: boolean;
  defaultCountry?: string;
  appIdMasked?: string | null;
  hasAppId: boolean;
}

export interface MapsSettingsRequest {
  provider: string;
  enabled: boolean;
  apiKey?: string;
  appId?: string;
  defaultCountry?: string;
  clearApiKey?: boolean;
  clearAppId?: boolean;
}

export interface PlaceSuggestion {
  label: string;
  city?: string;
  region?: string;
  country?: string;
  lat?: number;
  lng?: number;
  placeId?: string;
}

@Injectable({providedIn: 'root'})
export class MapsAdminService {
  constructor(private http: HttpClient) {}

  getSettings(): Observable<MapsSettings> {
    return from(environment).pipe(
      switchMap((env: any) => this.http.get<MapsSettings>(`${env.backendURL}/api/admin/maps`))
    );
  }

  saveSettings(body: MapsSettingsRequest): Observable<MapsSettings> {
    return from(environment).pipe(
      switchMap((env: any) => this.http.put<MapsSettings>(`${env.backendURL}/api/admin/maps`, body))
    );
  }

  testConnection(): Observable<{ok: boolean; message?: string; error?: string}> {
    return from(environment).pipe(
      switchMap((env: any) =>
        this.http.post<{ok: boolean; message?: string; error?: string}>(
          `${env.backendURL}/api/admin/maps/test`, {}))
    );
  }

  autocomplete(query: string, country?: string): Observable<PlaceSuggestion[]> {
    return from(environment).pipe(
      switchMap((env: any) => {
        let params = new HttpParams().set('q', query);
        if (country) {
          params = params.set('country', country);
        }
        return this.http.get<PlaceSuggestion[]>(`${env.backendURL}/api/places/autocomplete`, {params});
      })
    );
  }
}
